module.exports = __webpack_public_path__ + "img/samsung-galaxy-book-s-3.e2b0b5e.jpg";